import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const orderApi = {
  getOrders: async (filters: any = {}) => {
    const { status, startDate, endDate, page = 1, limit = 20 } = filters;

    let url = `${API_URL}/api/admin/orders?page=${page}&limit=${limit}`;

    if (status) {
      url += `&status=${status}`;
    }

    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getNextDayOrders: async () => {
    const response = await axios.get(`${API_URL}/api/admin/orders/next-day`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getOrderDetails: async (orderId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/orders/${orderId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  updateOrderStatus: async (orderId: string, status: string) => {
    const response = await axios.put(
      `${API_URL}/api/admin/orders/${orderId}/status`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  restoreOrder: async (orderId: string) => {
    const response = await axios.post(
      `${API_URL}/api/admin/orders/${orderId}/restore`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } }
    );
    return response.data;
  },

  assignDeliveryAgent: async (orders: string[], deliveryAgentId: string) => {
    const response = await axios.post(
      `${API_URL}/api/admin/orders/assign-delivery-agent`,
      { orders, deliveryAgentId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  generateOrderReportPdf: async (reportData: any) => {
    const response = await axios.post(
      `${API_URL}/api/admin/orders/generate-report-pdf`,
      reportData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
        responseType: 'blob',
      }
    );

    return response.data;
  },

  swapMeal: async (orderId: string, newMealId: string, mealIndex?: number) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/orders/${orderId}/swap-meal`,
      { newMealId, mealIndex },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  swapDrink: async (orderId: string, newDrinkId: string | null, drinkIndex?: number) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/orders/${orderId}/swap-drink`,
      { newDrinkId, drinkIndex },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  skipOrder: async (orderId: string) => {
    const response = await axios.post(
      `${API_URL}/api/admin/orders/${orderId}/skip`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  createAdhocOrder: async (orderData: any) => {
    const response = await axios.post(
      `${API_URL}/api/admin/orders/adhoc`,
      orderData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  updateOrderDietaryPreference: async (orderId: string, dietaryPreference: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/orders/${orderId}/dietary-preference`,
      { dietaryPreference, dietaryPreferences: dietaryPreference },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  sequenceOrder: async (orderId: string, sequenceData: any) => {
    const response = await axios.put(
      `${API_URL}/api/admin/orders/${orderId}/sequence`,
      sequenceData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  bulkSequenceOrders: async (sequences: any[]) => {
    const response = await axios.put(
      `${API_URL}/api/admin/orders/batch-sequence`,
      { sequences },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },
};

export default orderApi;
